<template>
    <div class="amanah">
        <div class="page">
            <div class="subpage">
                <div class="title-page">PERJANJIAN PEMBERIAN AMANAT <br />(KHUSUS UNTUK KONTRAK BERJANGKA MULTILATERAL)</div>
                <div class="perjanjian">PERHATIAN <br />PERJANJIAN INI MERUPAKAN KONTRAK HUKUM. HARAP DIBACA DENGAN SEKSAMA.</div>

                <div class="content">
                    Pada hari ini
                    <b
                        ><u>{{ currentDate | day }}</u> </b
                    >, tanggal
                    <b
                        ><u>{{ currentDate | date }}</u> </b
                    >, bulan
                    <b>
                        <u>{{ currentDate | month }}</u> </b
                    >, tahun
                    <b
                        ><u>{{ currentDate | year }}</u></b
                    >, kami yang mengisi perjanjian di bawah ini:
                </div>
                <div class="content">
                    <tr>
                        <td><span class="label">1. Nama</span></td>
                        <td>:</td>
                        <td>
                            {{ dataPrint.fullname ? dataPrint.fullname : "............................." }}
                        </td>
                    </tr>
                    <tr>
                        <td><span class="label">Pekerjaan/jabatan</span></td>
                        <td>:</td>
                        <td>
                            {{ dataPrint.pekerjaan ? dataPrint.pekerjaan : "............................." }}
                        </td>
                    </tr>
                    <tr>
                        <td><span class="label">Alamat</span></td>
                        <td>:</td>
                        <td>
                            {{ dataPrint.alamat ? dataPrint.alamat : "............................." }}
                        </td>
                    </tr>

                    <p>Dalam hal ini bertindak untuk dan atas nama sendiri atau perusahaan1) .... yang selanjutnya disebut Nasabah,</p>
                    <tr>
                        <td><span class="label">2. Nama</span></td>
                        <td>:</td>
                        <td>{{ dataPrint.broker_name ? dataPrint.broker_name : "-" }}</td>
                    </tr>
                    <tr>
                        <td><span class="label">Wakil Pialang Verifikator</span></td>
                        <td>:</td>
                        <td>Wakil Pialang</td>
                    </tr>
                    <tr>
                        <td><span class="label">Alamat</span></td>
                        <td>:</td>
                        <td>
                            Menara Rajawali 6th floor Jl. Dr Ide Agung Gede Anak Agung Mega Kuningan - South Jakarta
                        </td>
                    </tr>
                </div>

                <div class="content">
                    Dalam hal ini bertindak untuk dan atas nama PT. ABI KOMODITI BERJANGKA yang selanjutnya disebut Pialang Berjangka, Nasabah dan Pialang Berjangka
                    secara bersama-sama selanjutnya disebut Para Pihak.Para Pihak sepakat untuk mengadakan Perjanjian Pemberian Amanat untuk melakukan transaksi
                    penjualan maupun pembelian Kontrak Berjangka dengan ketentuan sebagai berikut:
                </div>
                <div class="content">
                    <ol>
                        <li>
                            <p class="sub-content">Margin dan Pembayaran Lainnya</p>
                            <ol>
                                <li>
                                    Nasabah menempatkan sejumlah dana (Margin) ke Rekening Terpisah (Segregated Account) Pialang Berjangka sebagai Margin awal dan
                                    wajib mempertahankannya sebagaimana ditetapkan.
                                </li>
                                <li>
                                    membayar biaya-biaya yang diperlukan untuk transaksi yaitu biaya transaksi, pajak, komisi, dan biaya pelayanan, biaya bunga
                                    sesuai tingkat yang berlaku, dan biaya lainnya yang dapat dipertanggungjawabkan berkaitan dengan transaksi sesuai amanat Nasabah,
                                    maupun biaya rekening Nasabah.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Pelaksanaan Amanat</p>
                            <ol>
                                <li>
                                    Setiap amanat yang disampaikan oleh Nasabah atau kuasanya yang ditunjuk secara tertulis oleh Nasabah, dianggap sah apabila
                                    diterima oleh Pialang Berjangka sesuai dengan ketentuan yang berlaku, dapat berupa amanat tertulis yang ditandatangani oleh
                                    Nasabah atau kuasanya, amanat telepon yang direkam, dan/atau amanat transaksi elektronik lainnya.
                                </li>
                                <li>
                                    Setiap amanat Nasabah yang diterima dapat langsung dilaksanakan sepanjang nilai Margin yang tersedia pada rekeningnya mencukupi
                                    dan eksekusinya tergantung pada kondisi dan sistem transaksi yang berlaku yang mungkin dapat menimbulkan perbedaan waktu terhadap
                                    proses pelaksanaan amanat tersebut. Nasabah harus mengetahui posisi Margin dan posisi terbuka sebelum memberikan amanat untuk
                                    transaksi berikutnya.
                                </li>
                                <li>
                                    Amanat Nasabah hanya dapat dibatalkan dan/atau diperbaiki apabila transaksi atas amanat tersebut belum terjadi. Pialang Berjangka
                                    tidak bertanggung jawab atas kerugian yang timbul akibat tidak terlaksananya pembatalan dan/atau perbaikan sepanjang bukan karena
                                    kelalaian Pialang Berjangka.
                                </li>
                                <li>
                                    Pialang Berjangka berhak menolak amanat Nasabah apabila harga yang ditawarkan atau diminta tidak wajar.
                                </li>
                                <li>
                                    Nasabah bertanggung jawab atas keamanan dan penggunaan <i>username</i> dan <i>password</i> dalam transaksi Perdagangan Berjangka,
                                    oleh karenanya Nasabah dilarang memberitahukan, menyerahkan atau meminjamkan <i>username</i> dan <i>password</i> kepada pihak
                                    lain, termasuk kepada pegawai Pialang Berjangka
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Antisipasi penyerahan barang</p>
                            <ol>
                                <li>
                                    Untuk kontrak-kontrak tertentu penyelesaian transaksi dapat dilakukan dengan penyerahan atau penerimaan barang (delivery) apabila
                                    kontrak jatuh tempo. Nasabah menyadari bahwa penyerahan atau penerimaan barang mengandung risiko yang lebih besar daripada
                                    melikuidasi posisi dengan offset. Penyerahan fisik barang memiliki konsekuensi kebutuhan dana yang lebih besar serta tambahan
                                    biaya pengelolaan barang.
                                </li>
                                <li>
                                    Pialang Berjangka tidak bertanggung jawab atas klasifikasi mutu (grade), kualitas atau tingkat toleransi atas komoditi yang
                                    diserahkan atau akan diserahkan.
                                </li>
                                <li>
                                    Pelaksanaan penyerahan atau penerimaan barang tersebut akan diatur dan dijamin oleh Lembaga Kliring Berjangka.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Kewajiban Memelihara Margin</p>
                            <ol>
                                <li>
                                    Nasabah wajib memelihara/memenuhi tingkat Margin yang harus tersedia di rekening pada Pialang Berjangka sesuai dengan jumlah yang
                                    telah ditetapkan baik diminta ataupun tidak oleh Pialang Berjangka.
                                </li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>

            <div class="subpage">
                <div class="content">
                    <ol start="5">
                        <ol start="2">
                            <li>
                                Apabila jumlah Margin memerlukan penambahan maka Pialang Berjangka wajib memberitahukan dan memintakan kepada Nasabah untuk menambah
                                Margin segera.
                            </li>
                            <li>
                                Apabila jumlah Margin memerlukan tambahan (Call Margin) maka Nasabah wajib melakukan penyerahan Call Margin selambat- lambatnya
                                sebelum dimulai hari perdagangan berikutnya. Kewajiban Nasabah sehubungan dengan penyerahan Call Margin tidak terbatas pada jumlah
                                Margin awal.
                            </li>
                            <li>
                                Pialang Berjangka tidak berkewajiban melaksanakan amanat untuk melakukan transaksi yang baru dari Nasabah sebelum Call Margin
                                dipenuhi;
                            </li>
                            <li>
                                Untuk memenuhi kewajiban Call Margin dan keuangan lainnya dari Nasabah, Pialang Berjangka dapat mencairkan dana Nasabah yang ada di
                                Pialang Berjangka.
                            </li>
                        </ol>
                        <li>
                            <p class="sub-content">Hak Pialang Berjangka Melikuidasi Posisi Nasabah</p>
                            Nasabah bertanggung jawab memantau/mengetahui posisi terbukanya secara terus-menerus dan memenuhi kewajibannya. Apabila dalam jangka
                            waktu tertentu dana pada rekening Nasabah kurang dari yang dipersyaratkan, Pialang Berjangka dapat menutup posisi terbuka Nasabah secara
                            keseluruhan atau sebagian, membatasi transaksi, atau tindakan lain untuk melindungi diri dalam pemenuhan Margin tersebut dengan terlebih
                            dahulu memberitahu atau tanpa memberitahu Nasabah dan Pialang Berjangka tidak bertanggung jawab atas kerugian yang timbul akibat tindakan
                            tersebut.
                        </li>
                        <li>
                            <p class="sub-content">Penggantian Kerugian Tidak Menyerahkan Barang</p>
                            Apabila Nasabah tidak mampu menyerahkan komoditi atas Kontrak Berjangka yang jatuh tempo, Nasabah memberikan kuasa kepada Pialang
                            Berjangka untuk meminjam atau membeli komoditi untuk penyerahan tersebut. Nasabah wajib membayar secepatnya semua biaya, kerugian dan
                            premi yang telah dibayarkan oleh Pialang Berjangka atas tindakan tersebut. Apabila Pialang Berjangka harus menerima penyerahan komoditi
                            atau surat berharga maka Nasabah bertanggung jawab atas penurunan nilai dari komoditi atas surat berharga tersebut.
                        </li>
                        <li>
                            <p class="sub-content">Penggantian Kerugian Tidak Adanya Penutupan Posisi</p>
                            Apabila Nasabah tidak mampu melakukan penutupan atas transaksi yang jatuh tempo, Pialang Berjangka dapat melakukan penutupan atas
                            transaksi di Bursa. Nasabah wajib membayar biaya-biaya, termasuk biaya kerugian dan premi yang telah dibayarkan oleh Pialang Berjangka,
                            dan apabila Nasabah lalai untuk membayar biaya-biaya tersebut, Pialang Berjangka berhak untuk mengambil pembayaran dari dana Nasabah.
                        </li>
                        <li>
                            <p class="sub-content">Pialang Berjangka Dapat Membatasi Posisi</p>
                            Nasabah mengakui hak Pialang Berjangka untuk membatasi posisi terbuka Kontrak Berjangka Nasabah dan Nasabah tidak melakukan transaksi
                            melebihi batas yang telah ditetapkan tersebut.
                        </li>
                        <li>
                            <p class="sub-content">Tidak Ada Jaminan atas Informasi atau Rekomendasi</p>
                            Nasabah mengakui bahwa:
                            <ol>
                                <li>Informasi dan rekomendasi yang diberikan oleh Pialang Berjangka kepada Nasabah tidak selalu lengkap dan perlu diverifikasi.</li>
                                <li>Pialang Berjangka tidak menjamin bahwa informasi dan rekomendasi yang diberikan merupakan informasi yang akurat dan lengkap.</li>
                                <li>
                                    Informasi dan rekomendasi yang diberikan oleh Wakil PialangBerjangka yang satu dengan yang lain mungkin berbeda karena perbedaan
                                    analisis fundamental atau teknikal. Nasabah menyadari bahwa ada kemungkinan Pialang Berjangka dan pihak terafiliasinya memiliki
                                    posisi di pasar dan memberikan rekomendasi tidak konsisten kepada Nasabah.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Pembatasan Tanggung Jawab Pialang Berjangka.</p>
                            <ol>
                                <li>
                                    Pialang Berjangka tidak bertanggung jawab untuk memberikan penilaian kepada Nasabah mengenai iklim, pasar, keadaan politik dan
                                    ekonomi nasional dan internasional, nilai kontrak berjangka, kolateral, atau memberikan nasihat mengenai keadaan pasar. Pialang
                                    Berjangka hanya memberikan pelayanan untuk melakukan transaksi secara jujur serta memberikan laporan atas transaksi tersebut.
                                </li>
                                <li>
                                    Perdagangan sewaktu-waktu dapat dihentikan oleh pihak yang memiliki otoritas (Bappebti/Bursa Berjangka) tanpa pemberitahuan
                                    terlebih dahulu kepada Nasabah. Atas posisi terbuka yang masih dimiliki oleh Nasabah pada saat perdagangan tersebut dihentikan,
                                    maka akan diselesaikan (likuidasi) berdasarkan pada peraturan/ketentuan yang dikeluarkan dan ditetapkan oleh pihak otoritas
                                    tersebut, dan semua kerugian serta biaya yang timbul sebagai akibat dihentikannya transaksi oleh pihak otoritas perdagangan
                                    tersebut, menjadi beban dan tanggung jawab Nasabah sepenuhnya.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Transaksi Harus Mematuhi Peraturan Yang Berlaku</p>
                            Semua transaksi baik yang dilakukan sendiri oleh Nasabah maupun melalui Pialang Berjangka wajib mematuhi peraturan perundang- undangan di
                            bidang Perdagangan Berjangka, kebiasaan dan interpretasi resmi yang ditetapkan oleh Bappebti atau Bursa Berjangka.
                        </li>
                        <li>
                            <p class="sub-content">
                                Pialang Berjangka tidak Bertanggung jawab atas Kegagalan Komunikasi
                            </p>
                            Pialang Berjangka tidak bertanggung jawab atas keterlambatan atau tidak tepat waktunya pengiriman amanat atau informasi lainnya yang
                            disebabkan oleh kerusakan fasilitas komunikasi atau sebab lain diluar kontrol Pialang Berjangka.
                        </li>
                    </ol>
                </div>
            </div>
            <div class="subpage">
                <div class="content">
                    <ol start="13">
                        <li>
                            <p class="sub-content">Konfirmasi</p>
                            <ol>
                                <li>
                                    Konfirmasi dari Nasabah dapat berupa surat, telex, media lain, secara tertulis ataupun rekaman suara.
                                </li>
                                <li>
                                    Pialang Berjangka berkewajiban menyampaikan konfirmasi transaksi, laporan rekening, permintaan Call Margin, dan pemberitahuan
                                    lainnya kepada Nasabah secara akurat, benar dan secepatnya pada alamat Nasabah sesuai dengan yang tertera dalam rekening Nasabah.
                                    Apabila dalam jangka waktu 2 x 24 jam setelah amanat jual atau beli disampaikan, tetapi Nasabah belum menerima konfirmasi
                                    tertulis, Nasabah segera memberitahukan hal tersebut kepada Pialang Berjangka melalui telepon dan disusul dengan pemberitahuan
                                    tertulis.
                                </li>
                                <li>
                                    Jika dalam waktu 2 x 24 jam sejak tanggal penerimaan konfirmasi tertulis tersebut tidak ada sanggahan dari Nasabah maka
                                    konfirmasi Pialang Berjangka dianggap benar dan sah.
                                </li>
                                <li>
                                    Kekeliruan atas konfirmasi yang diterbitkan Pialang Berjangka akan diperbaiki oleh Pialang Berjangka sesuai keadaan yang
                                    sebenarnya dan demi hukum konfirmasi yang lama batal.
                                </li>
                                <li>
                                    Nasabah tidak bertanggung jawab atas transaksi yang dilaksanakan atas rekeningnya apabila konfirmasi tersebut tidak disampaikan
                                    secara benar dan akurat.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Kebenaran Informasi Nasabah</p>
                            Nasabah memberikan informasi yang benar dan akurat mengenai data Nasabah yang diminta oleh Pialang Berjangka dan akan memberitahukan
                            paling lambat dalam waktu 3 (tiga) hari kerja setelah terjadi perubahan, termasuk perubahan kemampuan keuangannya untuk terus
                            melaksanakan transaksi.
                        </li>
                        <li>
                            <p class="sub-content">Komisi Transaksi</p>
                            Nasabah mengetahui dan menyetujui bahwa Pialang Berjangka berhak untuk memungut komisi atas transaksi yang telah dilaksanakan, dalam
                            jumlah sebagaimana akan ditetapkan dari waktu ke waktu oleh Pialang Berjangka. Perubahan beban (fees) dan biaya lainnya harus disetujui
                            secara tertulis oleh Para Pihak
                        </li>
                        <li>
                            <p class="sub-content">Pemberian Kuasa Memperoleh Informasi Keuangan</p>
                            <ol>
                                <li>
                                    Nasabah memberikan kuasa kepada Pialang Berjangka untuk menghubungi bank, lembaga keuangan, Pialang Berjangka lain, atau
                                    institusi lain yang terkait untuk memperoleh keterangan atau verifikasi mengenai informasi yang diterima dari Nasabah. Nasabah
                                    mengerti bahwa investigasi mengenai data hutang pribadi dan bisnis dapat dilakukan oleh Pialang Berjangka apabila diperlukan.
                                    Nasabah diberikan kesempatan untuk memberitahukan secara tertulis dalam jangka waktu yang telah disepakati untuk melengkapi
                                    persyaratan yang diperlukan.
                                </li>
                                <li>
                                    Nasabah dapat juga memberikan kuasa kepada pihak lain (bukan Pengurus Pialang Berjangka, bukan Wakil Pialang Berjangka yang
                                    menanda-tangani perjanjian ini dan bukan pegawai Pialang Berjangka yang jabatannya satu tingkat di bawah Direksi) yang ditunjuk
                                    oleh Nasabah untuk menjalankan hak-hak yang timbul atas rekening, termasuk memberikan instruksi kepada Pialang Berjangka atas
                                    rekening yang dimiliki Nasabah, berdasarkan surat kuasa dalam bentuk dan isi yang tidak bertentangan dengan ketentuan Peraturan
                                    Perundang-undangan
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Pemindahan Dana</p>
                            Pialang Berjangka dapat setiap saat mengalihkan dana dari satu rekening ke rekening lainnya sehubungan dengan kegiatan transaksi yang
                            dilakukan Nasabah seperti Margin, pembayaran hutang, atau mengurangi defisit dalam rekening Nasabah, tanpa terlebih dahulu memberitahukan
                            kepada Nasabah. Transfer yang telah dilakukan akan segera diberitahukan secara tertulis kepada Nasabah.
                        </li>
                        <li>
                            <p class="sub-content">Pemberitahuan</p>
                            <ol>
                                <li>
                                    Semua komunikasi, uang, surat berharga, dan kekayaan lainnya harus dikirimkan langsung ke alamat Nasabah seperti tercantum dalam
                                    rekeningnya atau alamat lain yang ditetapkan/diberitahukan secara tertulis oleh Nasabah.
                                </li>
                                <li>
                                    Semua uang, harus disetor atau ditransfer langsung oleh Nasabah ke Rekening Terpisah Pialang Berjangka:
                                    <tr>
                                        <td><span class="label">Nama</span></td>
                                        <td>:</td>
                                        <td>
                                            PT ABI Komoditi Berjangka
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label">Alamat</span></td>
                                        <td>:</td>
                                        <td>
                                            Menara Rajawali 6th floor Jl. Dr Ide Agung Gede Anak Agung Mega Kuningan - South Jakarta
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><span class="label">Bank</span></td>
                                        <td>:</td>
                                        <td>
                                            Bank BCA
                                        </td>
                                    </tr>
                                    <div><span class="label">No. Rekening Terpisah</span> : 0353197956 (IDR)</div>
                                    <div><span class="label">No. Rekening Terpisah</span> : 0358756363 (USD)</div>
                                    <tr>
                                        <td><span class="label">Bank</span></td>
                                        <td>:</td>
                                        <td>
                                            Bank CIMB NIAGA
                                        </td>
                                    </tr>
                                    <div><span class="label">No. Rekening Terpisah</span> : 860008133700 (IDR)</div>
                                    <div><span class="label">No. Rekening Terpisah</span> : 860008134940 (USD)</div>
                                    dan dianggap sudah diterima oleh Pialang Berjangka apabila sudah ada tanda terima bukti setor atau transfer dari pegawai Pialang
                                    Berjangka.
                                </li>

                                <li>
                                    Semua surat berharga, kekayaan lainnya, atau komunikasi harus dikirim kepada Pialang Berjangka:
                                    <tr>
                                        <td><span class="label">Nama</span></td>
                                        <td>:</td>
                                        <td>PT ABI KOMODITI BERJANGKA</td>
                                    </tr>
                                    <tr>
                                        <td><span class="label">Alamat</span></td>
                                        <td>:</td>
                                        <td>
                                            Menara Rajawali 6th floor Jl. Dr Ide Agung Gede Anak Agung Mega Kuningan - South Jakarta
                                        </td>
                                    </tr>
                                </li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>
            <div class="subpage">
                <div class="content">
                    <ol start="19">
                        <ol>
                            <div>
                                <div><span class="label">Telepon</span> : (021) 5761461</div>
                                <div><span class="label">Facsimile</span> : (021) 5761453</div>
                                <div><span class="label">E-mail</span> : info@abicommodity.co.id</div>

                                dan dianggap sudah diterima oleh Pialang Berjangka apabila sudah ada tanda bukti penerimaan dari pegawai Pialang Berjangka.
                            </div>
                        </ol>
                        <li>
                            <p class="sub-content">Dokumen Pemberitahuan Adanya Risiko</p>
                            Nasabah mengakui menerima dan mengerti Dokumen Pemberitahuan Adanya Risiko.
                        </li>
                        <li>
                            <p class="sub-content">Jangka Waktu Perjanjian dan Pengakhiran</p>
                            <ol>
                                <li>
                                    Perjanjian ini mulai berlaku terhitung sejak tanggal ditandatanganinya sampai disampaikannya pemberitahuan pengakhiran secara
                                    tertulis oleh Nasabah atau Pialang Berjangka.
                                </li>
                                <li>
                                    Nasabah dapat mengakhiri Perjanjian ini hanya jika Nasabah sudah tidak lagi memiliki posisi terbuka dan tidak ada kewajiban
                                    Nasabah yang diemban oleh atau terhutang kepada Pialang Berjangka.
                                </li>
                                <li>
                                    Pengakhiran tidak membebaskan salah satu Pihak dari tanggung jawab atau kewajiban yang terjadi sebelum pemberitahuan tersebut.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Berakhirnya Perjanjian</p>
                            Perjanjian dapat berakhir dalam hal Nasabah:
                            <ol>
                                <li>
                                    dinyatakan pailit, memiliki hutang yang sangat besar, dalam proses peradilan, menjadi hilang ingatan, mengundurkan diri atau
                                    meninggal;
                                </li>
                                <li>
                                    tidak dapat memenuhi atau mematuhi perjanjian ini dan/atau melakukan pelanggaran terhadapnya
                                </li>
                                <li>
                                    berkaitan dengan angka 1 dan 2 tersebut diatas, Pialang Berjangka dapat :
                                    <ol type="a">
                                        <li>
                                            meneruskan atau menutup posisi Nasabah tersebut setelah mempertimbangkannya secara cermat dan jujur ; dan
                                        </li>
                                        <li>menolak perintah dari Nasabah atau kuasanya.</li>
                                    </ol>
                                </li>
                                <li>
                                    Pengakhiran Perjanjian sebagaimana dimaksud dengan angka (1) dan (2) tersebut di atas tidak melepaskan kewajiban dari Para Pihak
                                    yang berhubungan dengan penerimaan atau kewajiban pembayaran atau pertanggungjawaban kewajiban lainnya yang timbul dari
                                    Perjanjian.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p class="sub-content">Force Majeur</p>
                            Tidak ada satupun pihak di dalam Perjanjian dapat diminta pertanggungjawabannya untuk suatu keterlambatan atau terhalangnya memenuhi
                            kewajiban berdasarkan Perjanjian yang diakibatkan oleh suatu sebab yang berada di luar kemampuannya atau kekuasaannya (force majeur),
                            sepanjang pemberitahuan tertulis mengenai sebab itu disampaikannya kepada pihak lain dalam Perjanjian dalam waktu tidak lebih dari 24
                            (dua puluh empat) jam sejak timbulnya sebab itu. Yang dimaksud dengan Force Majeur dalam Perjanjian adalah peristiwa kebakaran, bencana
                            alam (seperti gempa bumi, banjir, angin topan, petir), pemogokan umum, huru hara, peperangan, perubahan terhadap peraturan perundang-
                            undangan yang berlaku dan kondisi di bidang ekonomi, keuangan dan Perdagangan Berjangka, pembatasan yang dilakukan oleh otoritas
                            Perdagangan Berjangka dan Bursa Berjangka serta terganggunya sistem perdagangan, kliring dan penyelesaian transaksi Kontrak Berjangka di
                            mana transaksi dilaksanakan yang secara langsung mempengaruhi pelaksanaan pekerjaan berdasarkan Perjanjian.
                        </li>
                        <li>
                            <p class="sub-content">Perubahan atas Isian dalam Perjanjian Pemberian Amanat</p>
                            Perubahan atas isian dalam Perjanjian ini hanya dapat dilakukan atas persetujuan Para Pihak, atau Pialang Berjangka telah memberitahukan
                            secara tertulis perubahan yang diinginkan, dan Nasabah tetap memberikan perintah untuk transaksi dengan tanpa memberikan tanggapan secara
                            tertulis atas usul perubahan tersebut. Tindakan Nasabah tersebut dianggap setuju atas usul perubahan tersebut.
                        </li>
                        <li>
                            <p class="sub-content">Penyelesaian Perselisihan</p>
                            <ol>
                                <li>
                                    Semua perselisihan dan perbedaan pendapat yang timbul dalam pelaksanaan Perjanjian ini wajib diselesaikan terlebih dahulu secara
                                    musyawarah untuk mencapai mufakat antara Para Pihak.
                                </li>
                                <li>
                                    Apabila perselisihan dan perbedaan pendapat yang timbul tidak dapat diselesaikan secara musyawarah untuk mencapai mufakat, Para
                                    Pihak wajib memanfaatkan sarana penyelesaian perselisihan yang tersedia di Bursa Berjangka.
                                </li>
                                <li>
                                    Apabila perselisihan dan perbedaan pendapat yang timbul tidak dapat diselesaikan melalui cara sebagaimana dimaksud pada angka (1)
                                    dan angka (2), maka Para Pihak sepakat untuk menyelesaikan perselisihan melalui:
                                    <div class="pernyataan my-2">
                                        <input
                                            type="radio"
                                            name="statementDispute"
                                            id="1"
                                            value="bakti"
                                            v-model="statementDispute"
                                            required
                                            @change="handleValueDispute"
                                        /><label class="label-radio" for="">Badan Arbitrase Perdagangan Berjangka Komoditi (BAKTI)</label>

                                        <input
                                            type="radio"
                                            name="statementDispute"
                                            id="2"
                                            value="district-court"
                                            v-model="statementDispute"
                                            @change="handleValueDispute"
                                        /><label class="label-radio" for="">Pengadilan Negeri Jakarta Selatan</label>
                                        <!-- <input
                                            v-if="statementDispute == 'district-court'"
                                            v-model="district_court"
                                            type="text"
                                            class="form-input"
                                            placeholder="masukkan pengadilan negeri"
                                            @input="handleDistrictCourt"
                                        /> -->
                                    </div>
                                </li>
                                <li>
                                    Kantor atau kantor cabang Pialang Berjangka terdekat dengan domisili Nasabah tempat penyelesaian dalam hal terjadi perselisihan.
                                </li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>
            <div class="subpage">
                <div class="content">
                    <ol start="25">
                        <ol>
                            <table class="wrap-branch-office">
                                <thead>
                                    <tr>
                                        <th>Daftar Kantor</th>
                                        <th class="text-center">Kantor yang dipilih</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div>
                                                a. PT. ABI KOMODITI BERJANGKA
                                            </div>
                                            <small>Menara Rajawali 6th floor Jl. Dr Ide Agung Gede Anak Agung Mega Kuningan - South Jakarta</small>
                                        </td>
                                        <td class="text-center">
                                            <input type="checkbox" name="" id="" checked />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ol>
                        <li>
                            <p class="sub-content">Bahasa</p>
                            Perjanjian ini dibuat dan ditandatangani dalam Bahasa Indonesia.
                        </li>
                    </ol>
                </div>
                <div class="content">
                    Demikian Perjanjian Pemberian Amanat ini dibuat oleh Para Pihak dalam keadaan sadar, sehat jasmani rohani dan tanpa unsur paksaan dari pihak
                    manapun.
                </div>
                <div class="content">
                    <div class="penutup">
                        <div class="content-penutup">
                            'Saya telah membaca, mengerti, dan setuju terhadap semua ketentuan yang tercantum dalam perjanjian ini'
                        </div>
                        <div class="content-penutup">
                            Dengan mengisi kolom “YA” di bawah ini, saya menyatakan bahwa saya telah menerima
                            <div>"PERJANJIAN PEMBERIAN AMANAT TRANSAKSI KONTRAK BERJANGKA"</div>
                            mengerti dan menyetujui isinya
                        </div>
                        <div class="wrap-pernyataan">
                            <div class="pernyataan">
                                <div class="label">Pernyataan menerima/tidak</div>
                                <div>
                                    <input type="radio" name="radios" id="1" :value="true" v-model="statement" required @change="handleValue" /><label
                                        class="label-radio"
                                        for=""
                                        >Ya</label
                                    >

                                    <input type="radio" name="radios" id="2" :value="false" v-model="statement" @change="handleValue" /><label
                                        class="label-radio"
                                        for=""
                                        >Tidak</label
                                    >
                                </div>
                            </div>
                            <div class="pernyataan">
                                <div class="label">Menerima Pada Tanggal</div>
                                <div>
                                    {{ currentDate | formatDateTime }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
export default {
    props: {
        statement: Boolean,
        fullName: String,
        dataPrint: Object,
        disputeValue: String,
    },
    data() {
        return {
            currentDate: "",
            customer_complaints_settlement: "",
            // statementDispute: "",
            district_court: "Jakarta Selatan",
        };
    },
    created() {
        if (this.dataPrint.tanggal_diterima) {
            this.currentDate = this.dataPrint.tanggal_diterima;
        } else {
            this.currentDate = new Date();
        }
    },
    computed: {
        statementDispute: {
            get() {
                return this.disputeValue;
            },
            set(value) {
                return value;
            },
        },
    },
    methods: {
        handleValue(e) {
            this.$emit("changeValue", e.target._value);
        },
        handleValueDispute(e) {
            this.district_court = "";
            this.$emit("changeValueDispute", e.target.value);
        },
        handleDistrictCourt(e) {
            this.$emit("changeDistrictCourt", e.target.value);
        },
        customerComplaint(e) {
            this.customer_complaints_settlement = e.target.value;
            this.$emit("selectCustomerComplaint", this.customer_complaints_settlement);
            this.$root.$emit("selectCustomerComplaint", this.customer_complaints_settlement);
        },
    },
};
</script>

<style scoped>
.tanda-tangan {
    margin: -70px -45px 0;
    width: 253px;
}

.subpage {
    padding-inline: 1cm;
    /* height: 276.5mm; */
    /* padding: 10mm; */
    margin: 0.5mm auto;
    /* border: 1px red solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.radio {
    margin: 0 60px 0 -10px;
    line-height: 35px;
}

.radio .inner {
    width: 11px;
    height: 11px;
}

.radio .outer {
    width: 15px;
    height: 15px;
}

.label {
    width: 130px;
    margin-right: 15px;
}

.uppercase {
    text-transform: lowercase;
}

.uppercase:first-letter,
.uppercase:first-line {
    text-transform: capitalize;
}

.wrap-document {
    width: 90%;
    margin: auto;
    padding: 30px 50px;
    /* border-style: outset; */
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title-page {
    font-weight: bold;
    text-align: center;
    margin-block-end: 1.5rem;
    font-size: 14px;
}

.wrap-branch-office {
    width: 75%;
    margin: 0 auto;
    margin-bottom: 1rem;
}

.wrap-branch-office thead th {
    padding: 0.5rem 0;
}

.perjanjian {
    text-align: center;
    border: solid 2px #4a4a4a;
    padding: 10px 30px;
    margin: 0 0 30px;
}

.content {
    font-size: 12px;
    text-align: justify;
}

.sub-content {
    font-weight: 700;
    margin-bottom: 0.3rem;
}

form {
    margin: 20px 0;
    text-align: right;
    font-weight: 700;
}

ol {
    margin-left: 11px;
}

.penutup {
    font-weight: normal;
    margin-bottom: 2rem;
    margin-top: 1rem;
    font-size: 13px;
}

.content-penutup {
    width: 80%;
    text-align: center;
    margin: auto;
}

.title-penutup {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
}

.wrap-pernyataan {
    width: 50%;
    margin: 0 auto;
}

.pernyataan {
    display: flex;
    margin-top: 1rem;
    align-items: center;
}

/* .pernyataan:last-child {
  margin-top: unset;
} */

.label {
    width: 11rem;
}

.label-radio {
    margin-left: 0.6rem;
    margin-right: 1rem;
    margin-bottom: unset;
}

.resiko {
    font-weight: 700;
}

.persetujuan {
    /* width: 60%; */
    font-size: 12px;
    margin: 30px 0 90px;
}

.persetujuan div {
    display: flex;
    justify-content: space-between;
}

.persetujuan p {
    width: 180px;
    text-align: center;
    margin-bottom: 0;
}

.persetujuan div form {
    margin: 0;
    font-weight: normal;
}

.tanggal {
    margin-left: auto;
    margin-bottom: 10px !important;
}

.jabatan {
    margin-bottom: 70px !important;
}

.pt-abi {
    display: block !important;
    margin: 20px auto;
    width: 50%;
}

.pt-abi p {
    width: auto !important;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
    align-items: center;
}
/* 
@media print {
    .amanah {
        width: 210mm;
        height: 297mm;
    }
    .wrap-document {
        margin: 0;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
    }
} */

@media (max-width: 768px) {
    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .subpage{
        height: 100%;
        padding: 0;
    }

    .title-page {
        margin: 1.5rem auto;
    }

    .perjanjian {
        margin: 0 0 1rem;
    }

    .wrap-branch-office {
        width: 100%;
    }

    .wrap-pernyataan {
        width: 100%;
    }

    .content-penutup{
        width: 100%;
        margin-bottom: 0.5rem;
    }
}
</style>
